'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { cx } from '../../../internal/cx.js';
const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])';
/**
 * `role="toolbar"` with roving focus: Tab enters the toolbar, Left/Right
 * move between controls, Home/End jump. Text inputs keep their own arrow keys.
 */
export function Toolbar({ label, search, filters, end, className, children, onKeyDown, ...rest }) {
    const handleKey = useCallback((e) => {
        onKeyDown?.(e);
        if (e.defaultPrevented)
            return;
        const target = e.target;
        const isText = target instanceof HTMLInputElement &&
            !['checkbox', 'radio', 'button'].includes(target.type);
        if (isText && (e.key === 'ArrowLeft' || e.key === 'ArrowRight'))
            return;
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key))
            return;
        const items = Array.from(e.currentTarget.querySelectorAll(FOCUSABLE)).filter((el) => el.closest('[role="toolbar"]') === e.currentTarget);
        if (items.length === 0)
            return;
        const i = items.indexOf(document.activeElement);
        let next = i;
        if (e.key === 'ArrowRight')
            next = Math.min(i + 1, items.length - 1);
        if (e.key === 'ArrowLeft')
            next = Math.max(i - 1, 0);
        if (e.key === 'Home')
            next = 0;
        if (e.key === 'End')
            next = items.length - 1;
        if (next !== i) {
            e.preventDefault();
            items[next]?.focus();
        }
    }, [onKeyDown]);
    return (_jsxs("div", { className: cx('mn-toolbar-wrap', className), children: [_jsxs("div", { ...rest, role: "toolbar", "aria-label": label, className: "mn-toolbar", onKeyDown: handleKey, children: [search ? _jsx("div", { className: "mn-toolbar__search", children: search }) : null, children ? _jsx("div", { className: "mn-toolbar__group", children: children }) : null, end ? _jsx("div", { className: "mn-toolbar__end", children: end }) : null] }), filters ? _jsx("div", { className: "mn-toolbar__filters", children: filters }) : null] }));
}
/** Visual grouping inside a Toolbar. */
export function ToolbarGroup({ className, ...rest }) {
    return _jsx("div", { ...rest, role: "group", className: cx('mn-toolbar__group', className) });
}
//# sourceMappingURL=toolbar.js.map